import "../styles/toast.css"

import React, { useEffect } from "react";
import ReactDOM from "react-dom"
import PropTypes from "prop-types"

const Toast = ({ title, message, type, onClose, duration = 5000 }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose()
        }, duration)

        return () => clearTimeout(timer)
    }, [duration, onClose])

    const handleClose = () => {

    }

    return (
        <div className={`toast toast-${type}`}>
            <div className="toast-header">
                {title !== "none" ? (
                    <p className="toast-title">{title}</p>
                ) : (<div className="toast-title"></div>)}
                <button className="toast-close-button" onClick={onClose}>
                    ×
                </button>
            </div>
            <div className="toast-content">
                <p className="toast-message">{message}</p>
            </div>
        </div>
    )
}

Toast.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["success", "error"]).isRequired,
    onClose: PropTypes.func.isRequired,
    duration: PropTypes.number
}

export const generateToast = ({ title, message, type, duration }) => {
    const toastId = `toast-${Math.floor(100000 + Math.random() * 900000)}`;

    const toastContainer = document.createElement("div")
    toastContainer.id = toastId
    document.body.appendChild(toastContainer)

    const removeToast = () => {
        ReactDOM.unmountComponentAtNode(toastContainer);
        document.body.removeChild(toastContainer);
    }

    ReactDOM.render(
        <Toast title={title} message={message} type={type} duration={duration} onClose={removeToast} />,
        toastContainer
      );
}

export default Toast